module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12 titles"
  }, [_c('v-toolbar', {
    class: _vm.headerClass,
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Inputs")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('label', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:top",
      value: ({
        html: 'Upload File'
      }),
      expression: "{ html: 'Upload File' }",
      arg: "top"
    }],
    staticClass: "btn btn--icon btn--raised pointer",
    attrs: {
      "for": "file-input"
    }
  }, [_c('div', {
    staticClass: "btn__content"
  }, [_c('v-icon', [_vm._v("")])], 1)]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "file-input",
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.uploadClick($event.target)
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:top",
      value: ({
        html: 'Download File'
      }),
      expression: "{ html: 'Download File' }",
      arg: "top"
    }],
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.downloadClick
    }
  }, [_c('v-icon', [_vm._v("")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-content', {
    class: _vm.subheaderClass
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('icon', {
    attrs: {
      "name": "cubes",
      "scale": "1"
    }
  }), _vm._v(" Dimensions")], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "white content-color"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "xAxis"
    }
  }, [_vm._v("X Axis")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedxAxis),
      expression: "selectedxAxis"
    }],
    staticClass: "form-control select-option",
    attrs: {
      "id": "xAxis"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedxAxis = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changexAxis()
      }]
    }
  }, _vm._l((_vm.data.valueDimensions), function(vd) {
    return _c('option', [_vm._v(_vm._s(vd.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "input-dimensions"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "yAxis"
    }
  }, [_vm._v("Y Axis")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedyAxis),
      expression: "selectedyAxis"
    }],
    staticClass: "form-control select-option",
    attrs: {
      "id": "yAxis"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedyAxis = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeyAxis()
      }]
    }
  }, _vm._l((_vm.data.valueDimensions), function(vd) {
    return _c('option', [_vm._v(_vm._s(vd.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "input-dimensions"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Size")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedrAxis),
      expression: "selectedrAxis"
    }],
    staticClass: "form-control select-option",
    attrs: {
      "id": "size"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedrAxis = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changerAxis()
      }]
    }
  }, [_vm._l((_vm.data.valueDimensions), function(vd) {
    return _c('option', [_vm._v(_vm._s(vd.name))])
  }), _vm._v(" "), _vm._l((_vm.additionalSizeOptions), function(value, label) {
    return _c('option', {
      key: label
    }, [_vm._v(_vm._s(label))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "input-dimensions"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "colour"
    }
  }, [_vm._v("Colour")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedColour),
      expression: "selectedColour"
    }],
    staticClass: "form-control select-option",
    attrs: {
      "id": "colour"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedColour = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeColour()
      }]
    }
  }, _vm._l((_vm.data.categoryDimensions), function(cd) {
    return _c('option', [_vm._v(_vm._s(cd.name))])
  }), 0)])])])])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-content', {
    class: _vm.subheaderClass
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('icon', {
    attrs: {
      "name": "exchange",
      "scale": "1"
    }
  }), _vm._v(" Filter")], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "white content-color"
  }, [_c('v-btn', {
    attrs: {
      "light": "",
      "ripple": true
    },
    on: {
      "click": function($event) {
        return _vm.resetAll()
      }
    }
  }, [_vm._v("Reset All")]), _vm._v(" "), _vm._l((_vm.data.categoryDimensions), function(singleCategory, singleCategoryKey) {
    return _c('div', [_c('v-expansion-panel', {
      staticClass: "no-shadow-card"
    }, [_c('v-expansion-panel-content', {
      staticClass: "white content-color"
    }, [_c('div', {
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_vm._v(_vm._s(singleCategory.name))]), _vm._v(" "), _c('v-card', {
      staticClass: "no-shadow-card"
    }, [_c('v-card-text', {
      staticClass: "white content-color"
    }, [_c('v-btn', {
      staticClass: "buttonSelect",
      attrs: {
        "light": "",
        "ripple": true
      },
      on: {
        "click": function($event) {
          return _vm.selectAllClick(singleCategoryKey)
        }
      }
    }, [_vm._v("Select all")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "light": "",
        "ripple": true
      },
      on: {
        "click": function($event) {
          return _vm.selectAllClick(singleCategoryKey)
        }
      }
    }, [_vm._v("Reset")]), _vm._v(" "), _vm._l((_vm.filterData.filter[singleCategoryKey]), function(singleFilter) {
      return _c('div', [_c('div', {
        on: {
          "click": function($event) {
            return _vm.filterChart()
          }
        }
      }, [_c('v-checkbox', {
        staticClass: "check",
        attrs: {
          "tabindex": 0,
          "label": singleFilter.orderName,
          "hide-details": ""
        },
        model: {
          value: (singleFilter.isSelected),
          callback: function($$v) {
            _vm.$set(singleFilter, "isSelected", $$v)
          },
          expression: "singleFilter.isSelected"
        }
      })], 1)])
    })], 2)], 1)], 1)], 1)], 1)
  }), _vm._v(" "), _vm._l((_vm.data.valueDimensions), function(singleDimension, singleDimensionKey) {
    return _c('div', {
      on: {
        "click": function($event) {
          return _vm.sliderStart(singleDimensionKey)
        }
      }
    }, [_c('v-expansion-panel', {
      staticClass: "no-shadow-card"
    }, [_c('v-expansion-panel-content', {
      staticClass: "white content-color"
    }, [_c('div', {
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_vm._v(_vm._s(singleDimension.name))]), _vm._v(" "), _c('v-card', {
      staticClass: "no-shadow-card"
    }, [_c('v-card-text', {
      staticClass: "white content-color"
    }, [_c('v-btn', {
      attrs: {
        "light": "",
        "ripple": true
      },
      on: {
        "click": function($event) {
          return _vm.sliderReset(singleDimensionKey)
        }
      }
    }, [_vm._v("Reset")]), _vm._v(" "), _c('range-slider', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (true),
        expression: "true"
      }],
      ref: "slider",
      refInFor: true,
      attrs: {
        "min": _vm.filterData.filter[singleDimensionKey + _vm.data.categoryDimensions.length][0].min,
        "value": [_vm.filterData.filter[singleDimensionKey + _vm.data.categoryDimensions.length][0].values[0], _vm.filterData.filter[singleDimensionKey + _vm.data.categoryDimensions.length][0].values[1]],
        "max": _vm.filterData.filter[singleDimensionKey + _vm.data.categoryDimensions.length][0].max
      },
      on: {
        "input": function($event) {
          return _vm.sliderFilter($event, singleDimensionKey)
        }
      }
    })], 1)], 1)], 1)], 1)], 1)
  })], 2)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cde0f1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputSection.vue
// module id = 1280
// module chunks = 1